import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createUploadComponent } from './Upload';
import { UPLOAD_BASE_CLASSNAME } from './Constants';
createComponents(".".concat(UPLOAD_BASE_CLASSNAME), createUploadComponent, NO_PATTERN_BUSINESS_LOGIC);
